const cache = {};
const DEFAULT_TTL = 5 * 60 * 1000; // 5 minutes

export const getCached = async (key, fetcher, ttl = DEFAULT_TTL) => {
  const entry = cache[key];
  const now = Date.now();

  if (entry && (now - entry.ts) < ttl) {
    return entry.data;
  }

  const data = await fetcher();
  cache[key] = { data, ts: now };
  return data;
};

export const invalidateCache = (key) => {
  if (key) {
    delete cache[key];
  } else {
    Object.keys(cache).forEach((k) => delete cache[k]);
  }
};
